import { io } from 'socket.io-client';

export function createSocketConnection() {
    const socketQueryParams = new URLSearchParams({
        referer: window.location.href,
        appInstanceId: window.appInstanceId,
        appVersion: window.lokaliseVersion,
        appType: 'react',
    });

    return io(`/?${socketQueryParams.toString()}`, {
        transports: ['websocket'],
        upgrade: false,
        path: window.env?.socketUrl,
    });
}

export const defaultConnection = createSocketConnection();
